<template>
  <div class="multi-add">
    <div class="empty-state" v-show="selectedItems.length <= 0">
      {{ emptyStateMessage }}
    </div>
    <div class="items" v-show="selectedItems.length > 0">
      <div
        class="item"
        :key="`selectedItem_${i}`"
        v-for="(item, i) in selectedItems"
      >
        {{ item }}
        <a class="icon-container" @click="removeItem(i)">
          <i class="bdg-icon trash fa-fw text-lg text-red" />
        </a>
      </div>
    </div>
    <div class="mt-4">
      <bdg-text-add
        :name="addItemText"
        @added="addItem"
        v-model="itemToAdd"
        required
      />
    </div>
  </div>
</template>

<script>
import BdgTextAdd from "./BdgTextAdd";

export default {
  name: "MultiAdd",
  components: { BdgTextAdd },
  props: {
    emptyStateMessage: {
      type: String,
      default: "No items added"
    },
    addItemText: {
      type: String,
      default: "Add item"
    },
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      itemToAdd: undefined
    };
  },
  computed: {
    selectedItems: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  methods: {
    addItem() {
      this.selectedItems.push(this.itemToAdd);
      this.selectedItems = this.selectedItems.slice();
      this.itemToAdd = undefined;
    },
    removeItem(index) {
      this.$emit("removed", this.selectedItems[index]);
      this.selectedItems.splice(index, 1);
      this.selectedItems = this.selectedItems.slice();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../scss/assets";

.multi-add {
  .empty-state {
    @apply flex justify-center items-center border border-dashed border-red mb-2 p-3 text-placeholder-gray;
  }

  .items {
    .item {
      @apply flex justify-between items-center w-full px-4 py-3;

      @include striped($light: true);
    }
  }
}
</style>
